// extracted by mini-css-extract-plugin
export var cookieBanner = "CookieBanner-module--cookieBanner--7_3PX";
export var animated = "CookieBanner-module--animated--1qMvJ";
export var fadeInUp = "CookieBanner-module--fadeInUp--12x8h";
export var cookieBannerContents = "CookieBanner-module--cookieBannerContents--A9z05";
export var closeIcon = "CookieBanner-module--closeIcon--E_EBO";